import React from 'react';

import classNames from 'classnames';

import styles from './index.scss';

export type ChipSubLabelVariant = 'default' | 'warning' | 'critical';

type ChipButtonProps<ValueType> = {
  value: ValueType;
  children: React.ReactNode;
  isChecked: boolean;
  onClick: (value: ValueType) => void;
  disabled?: boolean;
  subLabel?: string;
  subLabelVariant?: ChipSubLabelVariant;
  fixedSize?: boolean;
};

export default function ChipButton<ValueType>({
  value,
  children,
  isChecked,
  onClick,
  disabled = false,
  subLabel,
  subLabelVariant = 'default',
  fixedSize = false,
}: ChipButtonProps<ValueType>) {
  return (
    <button
      className={classNames(styles.chipButton, {
        [styles.fixedSize]: fixedSize,
        [styles.checked]: isChecked,
        [styles.disabled]: disabled,
      })}
      onClick={() => onClick(value)}
      aria-pressed={isChecked}
      aria-disabled={disabled}
      disabled={disabled}
    >
      <span className={styles.label}>{children}</span>
      {subLabel ? (
        <span
          className={classNames(styles.subLabel, {
            [styles.subLabelWarning]: !disabled && subLabelVariant === 'warning',
            [styles.subLabelCritical]: !disabled && subLabelVariant === 'critical',
          })}
        >
          {subLabel}
        </span>
      ) : null}
    </button>
  );
}
